__turbopack_context__.v({
  "point": "offer-module-scss-module__MAFMOq__point",
  "tarif": "offer-module-scss-module__MAFMOq__tarif",
  "tarif_badge": "offer-module-scss-module__MAFMOq__tarif_badge",
  "tarif_bg_1": "offer-module-scss-module__MAFMOq__tarif_bg_1",
  "tarif_bg_2": "offer-module-scss-module__MAFMOq__tarif_bg_2",
  "tarif_blur_area": "offer-module-scss-module__MAFMOq__tarif_blur_area",
  "tarif_btn": "offer-module-scss-module__MAFMOq__tarif_btn",
  "tarif_btn_current": "offer-module-scss-module__MAFMOq__tarif_btn_current",
  "tarif_header": "offer-module-scss-module__MAFMOq__tarif_header",
  "tarif_list": "offer-module-scss-module__MAFMOq__tarif_list",
  "tarif_price": "offer-module-scss-module__MAFMOq__tarif_price",
});
